import { render, staticRenderFns } from "./NewUserConfirmation.vue?vue&type=template&id=503e49b0"
import script from "./NewUserConfirmation.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewUserConfirmation.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports